// Fondative hexagon icon — gradient purple→red with the 3 bars
const LogoIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 100 115"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="fgrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#E5007A" />
        <stop offset="100%" stopColor="#7B2FBE" />
      </linearGradient>
    </defs>
    {/* Hexagon outline */}
    <polygon
      points="50,4 96,28 96,78 50,102 4,78 4,28"
      fill="none"
      stroke="url(#fgrad)"
      strokeWidth="8"
    />
    {/* Three bars (F logo) */}
    <rect x="30" y="36" width="40" height="8" rx="2" fill="url(#fgrad)" />
    <rect x="30" y="51" width="32" height="8" rx="2" fill="url(#fgrad)" />
    <rect x="30" y="66" width="20" height="8" rx="2" fill="url(#fgrad)" />
  </svg>
);

export default LogoIcon;
